module.exports = __webpack_public_path__ + "media/images/yellow-line-71b75096ad9c7a03f2aa83dbcb9d3da3.png";